import { skipToken } from '@reduxjs/toolkit/query';
import { useGetManualDetailsQuery } from '../../apis/publicationsApi';
import useManualSotExpApiConfig from './useManualSotExpApiConfig';
const useFetchManualPublicationDetails = (queryParams) => {
    const { headers, baseUrl } = useManualSotExpApiConfig();
    const url = `${baseUrl}/publications/details`;
    const { data, isError, isFetching, isSuccess, isUninitialized } = useGetManualDetailsQuery(queryParams
        ? {
            url,
            headers,
            queryParams,
        }
        : skipToken);
    return { data, isError, isFetching, isSuccess, isUninitialized };
};
export default useFetchManualPublicationDetails;
